/** Values are the API names; the API rejects numeric strings. */
export enum MinorBreakRule {
  CONTINUOUS_WORK = 'MinorBreakContinuousWork',
  LEGAL_WORK_TIME = 'MinorBreakLegalWorkTime',
}
